import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { setOpenKYCModal } from "../../../redux/userSlice"
import Modal from "../../../components/Modal"
import PANDetails from "../../../components/KYCComponents/PANDetails"
import AadharDetails from "../../../components/KYCComponents/AadharDetails"
import Submit from "./Submit"
import { CloseIcon } from "../../../assets/Icons/commonIcon"

const KYCModal = () => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state)
  const { BankDetails = [], panNumber, aadharNumber, openKYCModal } = state.user
  return (
    <>
      <Modal
        visible={openKYCModal}
        onClose={() => dispatch(setOpenKYCModal(false))}
      >
        <div className="w-[1080px] h-[720px] bg-gradient-to-b from-[#9BD7D0] from-0%  to-[#FFFFFF] to-50% rounded-[24px] overflow-hidden">
          <div className="flex justify-end w-[100%] absolute top-[20px] right-[20px]">
            <a
              onClick={() => dispatch(setOpenKYCModal(false))}
              className="cursor-pointer"
            >
              <CloseIcon />
            </a>
          </div>

          {!panNumber ? (
            <PANDetails />
          ) : !aadharNumber ? (
            <AadharDetails />
          ) : !BankDetails?.length ? (
            <BankDetails />
          ) : (
            <Submit />
          )}
        </div>
      </Modal>
    </>
  )
}

export default KYCModal
